import Vue from 'vue';
import Vuex from 'vuex';
import authriozation from './modules/authriozation';
import { services } from '@/service';
import { Notification } from 'element-ui';
import { uniqueId } from 'lodash';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { authriozation },
  state: {
    setSelectionFn: null,
    fieldEditorShow: false,
    curCoursewareVersion: null
  },
  getters: {
    isCheckingVersion: state => !!state.curCoursewareVersion
  },
  actions: {
    updFieldEditorShow({ state }, show) {
      state.fieldEditorShow = show;
    },
    initSelectionFetcher({ state }, fn) {
      state.setSelectionFn = fn;
    },
    clearSelectionFetcher({ state }) {
      state.setSelectionFn = null;
    },
    updCoursewareVersion({ state, dispatch }, courseDetail) {
      dispatch('clearCourseVersion');

      const checkVersion = () => {
        const curCheckUniqueId = state.curCoursewareVersion.uniqueId;

        state.curCoursewareVersion.timeourController = setTimeout(async () => {
          try {
            const result = await services.courseware.checkVersion(
              state.curCoursewareVersion.id,
              state.curCoursewareVersion.version || 0
            );

            if (!state.curCoursewareVersion || state.curCoursewareVersion.uniqueId !== curCheckUniqueId) {
              return;
            }

            if (result.check_version) {
              checkVersion();
            } else {
              state.curCoursewareVersion.notify = Notification({
                title: '提示',
                type: 'warning',
                duration: 0,
                showClose: false,
                message: '当前页面课题已被其他用户修改，为保证内容一致，建议您刷新后再重新编辑。'
              });
            }
          } catch (err) {
            checkVersion();
          }
        }, 5000);
      };

      state.curCoursewareVersion = {
        uniqueId: uniqueId(),
        id: courseDetail._id,
        version: courseDetail._source.timestamp_version,
        notify: null,
        timeourController: 0
      };
      if (process.env.NODE_ENV === 'production') {
        checkVersion();
      }
    },
    clearCourseVersion({ state }) {
      if (!state.curCoursewareVersion) {
        return;
      }

      if (state.curCoursewareVersion.notify) {
        state.curCoursewareVersion.notify.close();
        state.curCoursewareVersion.notify = null;
      }
      if (state.curCoursewareVersion.timeourController) {
        clearTimeout(state.curCoursewareVersion.timeourController);
        state.curCoursewareVersion.timeourController = 0;
      }
      state.curCoursewareVersion = null;
    }
  }
});
